import { render, staticRenderFns } from "./SuccessGooglePay.vue?vue&type=template&id=33ef5b47&scoped=true&"
import script from "./SuccessGooglePay.vue?vue&type=script&lang=js&"
export * from "./SuccessGooglePay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ef5b47",
  null
  
)

export default component.exports